import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { openGamePlethora } from "../../utils/providerOpenHandlers";
import { useNavigate, useLocation } from "react-router";
import { fetchFinalStatus } from "../../store/contest/contest-actions";
import ScrollLTR from "../../components/ui/scrollLTR/ScrollLTR";
import WaitingForFinalOpenMode from "./WaitingForFinalOpenMode/WaitingForFinalOpenMode";
import WarningBar from "./WaitingForFinalOpenMode/WarningBar/WarningBar";
import MainSectionsFinalPage from "./MainSectionsFinalPage/MainSectionsFinalPage";
import FinalHeaderPage from "./FinalheaderPage/FinalHeaderPage";
import FinalEndPopup from "./FinalPopup/FinalEnd/FinalEndPopup";
import classes from "./FinalPage.module.css";
import UnidentifiedHeader from "../ContestPage/unidentifiedHeader/UnidentifiedHeader";

export const FinalPage = () => {

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const { finalData, initContestData } = useSelector((state) => state.contest);
  const { school } = useSelector((state) => state.auth);
  const { texts, lang } = useSelector((state) => state.translate);
  const [finalPageMode, setFinalPageMode] = useState({ mainMode: true, waitingMode: false });
  const [showFinalEndPopup, setShowFinalEndPopup] = useState(false);
  const [lockBtnWhenChackIsAllowed, setLockBtnWhenChackIsAllowed] = useState(false);
  const [{ showWarning, textWarning }, setShowWarning] = useState({ showWarning: false, textWarning: '' });
  const isInIframe = window.self !== window.top;

  useEffect(() => {
    if (location.state?.navigation !== 'InitiatedTransferWithUserInteraction' || !initContestData)
      navigate('/');
  }, [location, initContestData, navigate]);

  const onBackClick = () => {
    if (finalPageMode.mainMode)
      navigate(`/`);
    else
      setFinalPageMode({ mainMode: true, waitingMode: false });
  };

  const handleEnterFinalClick = async () => {
    if (!school?.id)
      return;
    setLockBtnWhenChackIsAllowed(true);
    const result = await dispatch(fetchFinalStatus(school?.id));
    setLockBtnWhenChackIsAllowed(false);
    if (!result?.ok) {
      setShowWarning({ showWarning: true, textWarning: texts?.tryAgainMessageInMainPage });
      setLockBtnWhenChackIsAllowed(false);
      return;
    }
    const { isFinalEnd, isFinalOpen, isTeamMember, finalGameUrl } = result.finalStatus ?? {};
    if (isFinalEnd) {
      setShowFinalEndPopup(true);
      return;
    }
    if (isFinalOpen && isTeamMember) {
      openGamePlethora(finalGameUrl, lang)
      return;
    }
    setFinalPageMode({ mainMode: false, waitingMode: true });
  };

  return (
    <>
      {!isInIframe && <UnidentifiedHeader />}
      <div className={classes.finalPage}>
        <FinalHeaderPage onBack={onBackClick} />
        <ScrollLTR dropClass={classes.scrollLTR}>
          {finalPageMode.waitingMode ?
            <WaitingForFinalOpenMode targetDate={finalData?.finalTargetDate} setFinalPageMode={setFinalPageMode} />
            :
            <MainSectionsFinalPage onEnterFinal={handleEnterFinalClick} lockBtnWhenChackIsAllowed={lockBtnWhenChackIsAllowed} />
          }
        </ScrollLTR>
        {showFinalEndPopup && <FinalEndPopup onClose={() => setShowFinalEndPopup(false)} setFinalPageMode={setFinalPageMode} />}
        {showWarning && <WarningBar text={textWarning} color="#F03C3C" durationMs={10000} onDismiss={() => setShowWarning({ showWarning: false, textWarning: '' })} />}
      </div>
    </>
  );
};

export default FinalPage;